import { FormGroup, Input, Label } from "reactstrap";
import DefaultModal from "./Default";
import DefaultButton from "../Buttons/Default";
import { useState } from "react";
import { API_URL } from "../../utils/constants";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "react-i18next";

function ProfileSettingsModal({isOpen, toggle, user}) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [state, setState] = useState({
    name: user?.name || '',
    phoneNumber: user?.phone_number || '',
    instagramLink: user?.instagram_link || '',
    tiktokLink: user?.tiktok_link || '',
    bio: user?.bio || ''
  });

  const update = async () => {
    setIsLoading(true);
    const response = await fetch(API_URL+'/user/account/update', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        name: state.name,
        phone_number: state.phoneNumber,
        instagram_link: state.instagramLink,
        tiktok_link: state.tiktokLink,
        bio: state.bio
      }),
    });
    const data = await response.json();      
    if (data.success) {
      toast.success('تم تحديث بيانات الحساب بنجاح');
      localStorage.setItem('user', JSON.stringify(data.user));
      toggle();
    } else {
      console.log("Error:", data);
    }
    setIsLoading(false);
  };

  return(
    <DefaultModal
      isOpen={isOpen}
      toggle={toggle}
      title={ t('profile.edit_profile') }
      size="md"
    >
      <ToastContainer 
        pauseOnFocusLoss={false}
        pauseOnHover={false}
        autoClose={2000}
      />

      <div className="text-center">
        <img src={ require('../../assets/images/edit-magic.png') } alt="" />
      </div>

      <FormGroup>
        <Label>{ t('profile.fullname') }: </Label>
        <Input 
          type="text" 
          value={state.name} 
          onChange={(e) => setState({...state, name: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.phone_number') }: </Label>
        <Input 
          type="text" 
          value={state.phoneNumber} 
          onChange={(e) => setState({...state, phoneNumber: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.instagram') }: </Label>
        <Input 
          type="text" 
          value={state.instagramLink} 
          onChange={(e) => setState({...state, instagramLink: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.tiktok') }: </Label>
        <Input 
          type="text" 
          value={state.tiktokLink} 
          onChange={(e) => setState({...state, tiktokLink: e.target.value})}
        />
      </FormGroup>
      <FormGroup>
        <Label>{ t('profile.description') }: </Label>
        <Input 
          type="textarea" 
          value={state.bio}
          onChange={(e) => setState({...state, bio: e.target.value})}
        />
      </FormGroup>
      <div className="text-center">
        <DefaultButton
          loading={isLoading}
          onClick={update}
        >
          { t('profile.save') }
        </DefaultButton>
      </div>
    </DefaultModal>
  );
}

export default ProfileSettingsModal;